import React from 'react';

interface AspirationsQuestionsProps {
  responses: Record<string, any>;
  onChange: (responses: Record<string, any>) => void;
}

export function AspirationsQuestions({ responses, onChange }: AspirationsQuestionsProps) {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Your Career Aspirations</h2>
      
      <div className="space-y-4">
        <div>
          <label htmlFor="dream_role" className="block text-sm font-medium text-gray-700">
            What is your dream role?
          </label>
          <input
            type="text"
            id="dream_role"
            value={responses.dream_role || ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ dream_role: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          />
        </div>

        <div>
          <label htmlFor="timeline" className="block text-sm font-medium text-gray-700">
            When would you like to achieve this goal?
          </label>
          <select
            id="timeline"
            value={responses.timeline || ''}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange({ timeline: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          >
            <option value="">Select timeline</option>
            <option value="6_months">Within 6 months</option>
            <option value="1_year">Within 1 year</option>
            <option value="2_years">Within 2 years</option>
            <option value="5_years">Within 5 years</option>
            <option value="long_term">Long term goal</option>
          </select>
        </div>

        <div>
          <label htmlFor="motivation" className="block text-sm font-medium text-gray-700">
            What motivates you most in your career?
          </label>
          <select
            id="motivation"
            value={responses.motivation || ''}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange({ motivation: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          >
            <option value="">Select primary motivation</option>
            <option value="impact">Making an impact</option>
            <option value="growth">Professional growth</option>
            <option value="leadership">Leadership opportunities</option>
            <option value="innovation">Innovation and creativity</option>
            <option value="stability">Stability and security</option>
            <option value="compensation">Compensation and benefits</option>
          </select>
        </div>
      </div>
    </div>
  );
}